<template>
  <van-popup
    v-model="show"
    position="bottom"
    get-container="body"
    :style="{ width: '100%', height: '100%', backgroundColor: '#EDF2FB' }"
  >
    <van-nav-bar
      :title="titleText"
      left-arrow
      @click-left="show = false"
      >
    </van-nav-bar>
    <van-steps direction="vertical" :active="active">        
      <van-step
        v-for="(option,index) in opts"
        :key="index"
        class="step is-card">
        <p class="step-time">{{option.time}}</p>
        <div class="step-title">{{option.name}}</div>
        <div class="step-desc">
          <div>{{assigneeText}}<span>{{option.assignee}}</span></div>
          <div>{{durationText}}<span>{{option.duration}}</span></div>
        </div>
        <div class="step-status">{{option.type}}</div>
        <div slot="active-icon" class="circle-container active-icon"></div>
        <div slot="inactive-icon" class="circle-container inactive-icon"></div>
      </van-step>
    </van-steps>
  </van-popup>
</template>
<script>
  import { encode18bit }  from 'utils'
  export default {
    name: "emap-flow-steps-m",
    data() {
      return {
        show: false,
        titleText: '流程状态',
        assigneeText: '经办人：',
        durationText: '耗时：',
        confirmText: '确定'
      }
    },
    props: {
      value: Boolean,
      defkey: String,
      taskid: String,
      options: Array
    },
    watch: {
      value: function(newval) {
        this.show = newval
      },
      show: function(newval) {
        this.$emit('input', newval)
      }
    },
    computed: {
      opts() {
        return this.options.map(opt => {
          if(opt.assignee) {
            let id = opt.assignee.match(/\((.+?)\)/g)[0];
            id = id.substring(1,id.length-1);
            id = encode18bit(id);
            opt.assignee = opt.assignee.replace(/\((.+?)\)/g, '(' + id + ')');
          }
          opt.time = opt.endTime ? opt.startTime + ' - ' + opt.endTime:opt.startTime + ' - 现在';
          return opt
        })
      },
      active() {
        return this.options.length?this.options.length-1:0;
      }
    },
    methods: {
      // ...
    },
    mounted () {
      // ...
    }
  }
</script>
<style lang="css">
  .van-steps {
    background-color: #EDF2FB;
    max-height: calc(100Vh - 46px);
    overflow: auto;
    padding: 15px 0 15px 52px;
  }
  .step {
    margin-top: 24px;
  }
  .step-time {
    position: absolute;
    top: -24px;
    left: 0;
    font-size: 12px;
    color: #767A8C;
    line-height: 24px;
    min-height: 24px;
  }
  .step-title {
    font-size: 14px;
    color: #13152D;
  }
  .step-desc {
    font-size: 12px;
    color: #767A8C;
    padding: 5px 0;
  }
  .step.is-card {
    background-color: #FFFFFF;
    padding: 17px 12px 17px 17px;
    margin-right: 17px;
    border-radius: 4px;
  }
  .step.is-card::before {
    content: '';
    display: block;
    position: absolute;
    border-bottom: 7px solid #EDF2FB;
    border-top: 7px solid #EDF2FB;
    border-right: 7px solid #FFFFFF;
    top: 16px;
    left: -7px;
  }
  .step.is-card .van-step__circle-container {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: #D8D8D8;
    position: absolute;
    top: 26px;
    left: -26px;
    z-index: 1;
    -webkit-box-shadow: 0 4px 8px 0 rgba(118,122,140,0.50);
    box-shadow: 0 4px 8px 0 rgba(118,122,140,0.50);
  }
  .step.is-card .circle-container {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    position: relative;
    background-color: #FFFFFF;
    top: 4px;
    left: 4px;
    border: 0;
  }
  .step.is-card .circle-container::before {
    content: '';
    display: inline-block;
    position: relative;
    top: -5px;
    left: 2px;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: #EDF2FB;
  }
  .step.is-card.van-step--process .van-step__circle-container {
    background-color: #3B7BFF;
    box-shadow: 0 4px 8px 0 rgba(59,123,255,0.50)
  }
  .step.is-card.van-step--process .circle-container::before {
    background-color: #3B7BFF;
  }
  .step.is-card .van-step__line {
    background-color: #C4C9D9;
    left: -26px;
    top: 26px;
    height: calc(100% + 24px);
  }
  .go-back-btn {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
  }
</style>